import { Injectable } from '@angular/core';
import {
  API_METHODS,
  API_URL,
  OperationType,
} from 'common/constants/sm-constants';
import { environment } from 'src/environments/environment';
import {
  notificationDetailsForm,
  NotificationModel,
} from 'common/models/page-models/notification/notification-data.model';
import { FormDataService } from '../../base-data-services/form-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';
import { DatePipe } from '@angular/common';
import moment from 'moment';

@Injectable({
  providedIn: 'root',
})
export class NotificationFormDataService extends FormDataService<NotificationModel> {
  constructor(http: SmApiService, protected override ss: SystemService, private datePipe: DatePipe) {
    super(API_URL.addNotification, http, ss);
  }

  createInstance(): NotificationModel {
    return new NotificationModel();
  }
  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.getAnnouncementDetailsById,
      method: API_METHODS.post,
    };
    return edit;
  }

  override getUpdatePayload(data) {
    let payload;
    payload = {
      id: data.id,
    };
    return payload;
  }

  override afterGetData(model: NotificationModel): Promise<NotificationModel> {
    return new Promise<any>((resolve, reject) => {
      model.id = model.announcement_id;
      resolve(model);
    });
  }

  override getUpdateUrl() {
    return API_URL.editAnnouncement;
  }

  override getOperationType(data: any) {
    // Check if the 'announcement_id' exists
    if (data.hasOwnProperty('announcement_id')) {
      // If 'announcement_id' is present and not an empty string, it's an update operation
      return data.announcement_id !== '' ? OperationType.UPDATE : OperationType.CREATE;
    } else {
      // If 'announcement_id' is not present, it's a create operation
      return OperationType.CREATE;
    }
  }


  override modifyPostModel(formModel, dataModel) {
    console.log(formModel, dataModel);
    const submitData: any = new notificationDetailsForm();

    if (Array.isArray(formModel.group_id)) {
      formModel.group_id.forEach((id, index) => {
        submitData[`groupIds`] = [id];
      });
    }
    if (Array.isArray(formModel.branch_id)) {
      submitData['branchIds'] = [];  
      formModel.branch_id.forEach((id, index) => {
        submitData['branchIds'].push(id); 
      });
    }
    
    if (dataModel.announcement_id) {
      submitData.id = dataModel.announcement_id;
    }

    if (dataModel.send_to === 1) {
     
      submitData.send_to_all = 1;
      submitData.mode = 'email';
   
      const announcementDate = new Date(formModel.announcement_datetime);

      const formattedDate = announcementDate.toLocaleString('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(',', '');

      submitData.display_datetime = formattedDate;


      if (formModel.announcement_type === 'custom') {
        submitData.type = formModel.announcement_type;
        submitData.content = formModel.content;
      } else {
        submitData.type = formModel.announcement_type;
        submitData.email_template_id = formModel.template_id;
      }
    } else {
      submitData.send_to_all = 2;
      if (dataModel.submittedFrom === "assignmentAccepted") {
        submitData.studentIds = dataModel.student_ids && dataModel.student_ids.length ? dataModel.student_ids : [];
      } else {
        submitData.studentIds = formModel.student_ids && formModel.student_ids.length ? formModel.student_ids : [];
      }

      const announcementDate = new Date(formModel.announcement_datetime);

      const formattedDate = announcementDate.toLocaleString('en-CA', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: false
      }).replace(',', '');

      submitData.display_datetime = formattedDate;


      submitData.type = formModel.announcement_type;
      submitData.email_template_id = formModel.template_id;
      submitData.mode = 'email';
      submitData.content = formModel.content;
      if (dataModel.submittedFrom === "assignmentAccepted") {
        submitData.batch_id = dataModel.batch_id;
      } else {
        submitData.batch_id = formModel.batch_id;
      }

      const selectedRegions = [];

      if (formModel.east) {

        const eastRegion = dataModel.region_options.find(option => option.zone_name === "East");
        if (eastRegion)
          selectedRegions.push(eastRegion.id);
      }
      if (formModel.west) {
        const westRegion = dataModel.region_options.find(option => option.zone_name === "West");
        if (westRegion) selectedRegions.push(westRegion.id);
      }
      if (formModel.north) {
        const northRegion = dataModel.region_options.find(option => option.zone_name === "North");
        if (northRegion) selectedRegions.push(northRegion.id);
      }
      if (formModel.south) {
        const southRegion = dataModel.region_options.find(option => option.zone_name === "South");
        if (southRegion) selectedRegions.push(southRegion.id);
      }

      // Join selected region ids into a comma-separated string

      submitData.region = selectedRegions;

    }
    return submitData;
  }

  override modifyAPIResponse(response: any) {
    const dataModel = this.createInstance();

    dataModel.announcement_id = response?.details.id || '';

    dataModel.announcement_datetime =
      response?.details.display_datetime || '';


    dataModel.template_id =
      response?.details.email_template_id || '';
    dataModel.batch_id = response?.details.batch_id || '';
    dataModel.content = response?.details.content || '';
    dataModel.announcement_type = response?.details.type || '';
    dataModel.group_id = response?.details.announcement_group_detail?.map(
      (a: any) => a.group_id
    );
    dataModel.branch_id =
      response?.details.announcement_branch_detail?.map((a: any) => a.branch_id) || [];
    dataModel.student_ids =
      response?.details.announcement_student_detail?.map((a: any) => a.student_id) || [];
    const regions =
      response?.details.announcement_region_detail?.map((a: any) => a.region) || [];
    dataModel.region = regions.join(',');
    dataModel.east = regions.includes('east');
    dataModel.west = regions.includes('west');
    dataModel.north = regions.includes('north');
    dataModel.south = regions.includes('south');

    return dataModel;
  }

  override updatepostUrl() {
    return environment.apiUrl + API_URL.editAnnouncement;
  }
}

export { FormDataService };
